var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvidaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 18,
    viewBox: "0 0 290 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.732 42.34H257.509C251.046 42.34 247.235 44.9914 244.998 51.04L242.346 58H235.22L238.949 48.0571C241.932 40.1857 248.229 35.7114 256.763 35.7114H274.246L263.392 6.62857H254.526L257.012 0H267.949L289.74 58H282.615L276.732 42.34Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.307 6.62857H182.359C178.465 6.62857 176.559 4.88857 176.559 1.24286V0H191.307C207.299 0 220.307 13.0086 220.307 29C220.307 44.9914 207.299 58 191.307 58H176.559V25.6857H183.187V51.3714H191.307C203.653 51.3714 213.679 41.3457 213.679 29C213.679 16.6543 203.653 6.62857 191.307 6.62857Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.629 19.0571V58H145V19.0571H151.629ZM145 12.4286H151.629V0H145V12.4286Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8069 0H69.1326C73.0269 0 75.5955 1.82286 77.004 5.46857L84.544 25.6857H77.4183L67.8069 0ZM87.1126 51.3714H92.084C93.7412 51.3714 94.8183 50.6257 95.4812 49.0514L113.875 0H120.918L101.198 52.5314C99.7897 56.1771 97.2212 58 93.3269 58H89.5983L87.1126 51.3714Z",
    fill: "#1F1F1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5114 42.34H22.2886C15.8257 42.34 12.0143 44.9914 9.77714 51.04L7.12572 58H0L3.72857 48.0571C6.71143 40.1857 13.0086 35.7114 21.5429 35.7114H39.0257L28.1714 6.62857H19.3057L21.7914 0H32.7286L54.52 58H47.3943L41.5114 42.34Z",
    fill: "#1F1F1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvidaLogo);
export default __webpack_public_path__ + "static/media/avida-logo.15e324b0.svg";
export { ForwardRef as ReactComponent };